import React, { useEffect } from 'react';
import { Typography } from '@/UI/Components/Typography/Typography';
import DownloadAppButton from '@/UI/Components/DownloadAppButton/DownloadAppButton';
import { useParams } from 'react-router-dom';
import { Smartphone, CheckCircle } from 'react-feather';

const Verify: React.FC = () => {
	const { open } = useParams<{ open: 'cc' | 'np' }>();
	const destinations = {
		cc: {
			message: 'Redirigiendo a Centro de comando',
			url: 'https://admin.fincluyente.com.mx/es/verify?token='
		},
		np: {
			message: 'Redirigiendo a nuestra app',
			url: 'finclu://verify?code='
		}
	};
	useEffect(() => {
		const handleRedirect = () => {
			try {
				const urlParams = new URLSearchParams(window.location.search);
				const token = urlParams.get('token');
				if (token && open) {
					window.location.href = destinations[open].url + token;
				}
			} catch (err) {
				console.error(err);
			}
		};
		handleRedirect();
	}, []);

	return (
		<div className="bg-gradient-to-br from-[#4660ff] via-[#5a75ff] to-[#6e8aff] min-h-screen flex items-center justify-center p-4">
			<div className="w-full max-w-lg">
				<div className="bg-white rounded-2xl shadow-2xl overflow-hidden transform transition-all duration-300 hover:shadow-3xl">
					<div className="bg-gradient-to-r from-[#4660ff] to-[#5a75ff] p-6 md:p-8">
						<div className="flex flex-col items-center gap-4">
							<div className="w-24 h-24 bg-white rounded-full flex items-center justify-center shadow-lg transform transition-transform duration-300 hover:scale-105">
								<img src="/black-logo.png" alt="Fincluyente" className="w-16 h-16 object-contain" />
							</div>
							<Typography size={24} weight="bold" color="white">
								{open ? destinations[open].message : 'Redirigiendo'}
							</Typography>
						</div>
					</div>

					<div className="p-6 md:p-8 space-y-6">
						<div className="flex items-start gap-3 bg-blue-50 rounded-xl p-4 border border-blue-100">
							<Smartphone className="w-6 h-6 text-[#4660ff] flex-shrink-0 mt-0.5" />
							<Typography size={16} weight="semibold" color="black">
								Es necesario tener la app de Finclu instalada
							</Typography>
						</div>

						<div className="space-y-4">
							<div className="flex items-start gap-4 group">
								<div className="flex-shrink-0 w-10 h-10 bg-[#4660ff] rounded-full flex items-center justify-center text-white font-bold shadow-md group-hover:scale-110 transition-transform duration-200">
									<span>1</span>
								</div>
								<div className="flex-1 pt-2">
									<Typography size={16} weight="semibold" color="black">
										Presiona abrir con "Finclu"
									</Typography>
								</div>
							</div>

							<div className="flex items-start gap-4 group">
								<div className="flex-shrink-0 w-10 h-10 bg-[#4660ff] rounded-full flex items-center justify-center text-white font-bold shadow-md group-hover:scale-110 transition-transform duration-200">
									<span>2</span>
								</div>
								<div className="flex-1 pt-2">
									<Typography size={16} weight="semibold" color="black">
										Termina el proceso de registro en la app
									</Typography>
								</div>
							</div>
						</div>

						<div className="pt-4 border-t border-gray-200">
							<div className="flex flex-col items-center gap-4">
								<div className="flex flex-col items-center gap-2 text-gray-600">
									<CheckCircle className="w-5 h-5" />
									<Typography size={15} color="subtitle">
										En caso de no tener la app instalada, puedes descargarla aquí
									</Typography>
								</div>
								<div className="pt-2">
									<DownloadAppButton buttonColor="#4660ff" />
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};
export default Verify;
